/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const GET_ERROR = 'mbp-checkout/GET_ERROR';
export const LOAD_ERROR = 'mbp-checkout/LOAD_ERROR';
export const CLEAR_ERRORS = 'mbp-checkout/CLEAR_ERRORS';
export const LOGGED_ERROR_KEYS = 'mbp-checkout/LOGGED_ERROR_KEYS';
